const isValidOid = (value: string): boolean => {
    if (!value || value.length !== 24) return false;
    const base64regex = /^([0-9a-fA-F+/]{4})*(([0-9a-fA-F+/]{2}==)|([0-9a-fA-F+/]{3}=))?$/;
    return base64regex.test(value);
};

export default isValidOid;
